import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from './useAuth';

export function useCourtOwnerRole() {
  const { user } = useAuth();

  const { data: isCourtOwner = false, isLoading } = useQuery({
    queryKey: ['court-owner-role', user?.id],
    queryFn: async () => {
      if (!user?.id) return false;
      
      const { data, error } = await supabase.rpc('is_court_owner', {
        _user_id: user.id
      });
      
      if (error) {
        console.error('Error checking court owner role:', error);
        return false;
      }
      
      return data === true;
    },
    enabled: !!user?.id,
  });

  return { isCourtOwner, isLoading };
}
